import React, { PureComponent, Fragment } from 'react';

import { Form as AntForm, Spin as AntSpin, Button as AntButton, Input as AntInput, Radio as AntRadio, InputNumber as AntInputNumber } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { services } from '@comall-backend-builder/core';
import classnames from 'classnames';
import trim from 'lodash/trim';
import { errorHandle } from '../../services';
import './index.less';

interface ILiveProductAddStates {
    /**
     * 加载中
     */
    spinning: boolean;
    /**
     * 商品名称
     */
    name: string;
    /**
     * 价格
     */
    price_first: string;
    /**
     * sku code
     */
    sku_code: string;
    /**
     * sku id
     */
    sku_id: number;
    /**
     * 价格类型
     */
    price_type: number;
    /**
     * 第二个价格
     */
    price_second: string;
    /**
     * 已获取商品信息
     */
    get_product_success: boolean;
    /**
     * 价格异常提示文本
     */
    price_error_msg: string;
    /**
     * 一口价价格异常
     */
    price_type1_first_error: boolean;
    /**
     * 价格区间 - 最小价格异常
     */
    price_type2_first_error: boolean;
    /**
     * 价格区间 - 最大价格异常
     */
    price_type2_second_error: boolean;
    /**
     * 折扣价 - 市场价异常
     */
    price_type3_first_error: boolean;
    /**
     * 折扣价 - 折扣价异常
     */
    price_type3_second_error: boolean;
}

interface ILiveProductAddProps {
    click: () => void;
    form: FormComponentProps['form'];
}

const api = services.api;
/**
 * 新增直播商品
 */
class liveProductAdd extends PureComponent<ILiveProductAddProps, ILiveProductAddStates> {

    constructor(props: any) {
        super(props);
        this.state = {
            spinning: false,
            name: '',
            price_first: '',
            sku_code: '',
            sku_id: 0,
            price_type: 0,
            price_second: '',
            price_error_msg: '',
            price_type1_first_error: false,
            price_type2_first_error: false,
            price_type2_second_error: false,
            price_type3_first_error: false,
            price_type3_second_error: false,
            get_product_success: false
        };
    }

    // 新增商品
    handleSubmit = (e: any) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err: any, values: any) => {
            this.setState({ spinning: true });
            const { name, sku_code, price_type, price_type1_first, price_type2_first, price_type2_second, price_type3_first, price_type3_second } = values;
            const { sku_id } = this.state;
            
            let price_first = '';
            let price_second = '';

            if (!price_type) {
                this.setState({ 
                    price_error_msg: '请选择价格类型',
                    spinning: false,
                });
                return;
            }

            if (price_type === 1) {
                if (!price_type1_first) {
                    this.setState({
                        price_type1_first_error: true,
                        price_type2_first_error: false,
                        price_type2_second_error: false,
                        price_type3_first_error: false,
                        price_type3_second_error: false,
                        price_error_msg: '请输入一口价',
                        spinning: false,
                    });
                    return;
                } else {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: false,
                        price_type2_second_error: false,
                        price_type3_first_error: false,
                        price_type3_second_error: false,
                        price_error_msg: ''
                    });
                    price_first = price_type1_first;
                }
            }
            
            if (price_type === 2) {
                if (!price_type2_first) {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: true,
                        price_type2_second_error: false,
                        price_type3_first_error: false,
                        price_type3_second_error: false,
                        price_error_msg: '请输入价格区间的最小价格',
                        spinning: false,
                    });
                    return;
                } else if (!price_type2_second) {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: false,
                        price_type2_second_error: true,
                        price_type3_first_error: false,
                        price_type3_second_error: false,
                        price_error_msg: '请输入价格区间的最大价格',
                        spinning: false,
                    });
                    return;
                } else if (Number(price_type2_first) > Number(price_type2_second)) {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: true,
                        price_type2_second_error: true,
                        price_type3_first_error: false,
                        price_type3_second_error: false,
                        price_error_msg: '价格区间的最小价格不能大于最大价格',
                        spinning: false,
                    });
                    return;
                } else {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: false,
                        price_type2_second_error: false,
                        price_type3_first_error: false,
                        price_type3_second_error: false,
                        price_error_msg: '',
                    });
                    price_first = price_type2_first;
                    price_second = price_type2_second;
                }
            }

            if (price_type === 3) {
                if (!price_type3_first) {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: false,
                        price_type2_second_error: false,
                        price_type3_first_error: true,
                        price_type3_second_error: false,
                        price_error_msg: '请输入市场价',
                        spinning: false,
                    });
                    return;
                } else if (!price_type3_second) {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: false,
                        price_type2_second_error: false,
                        price_type3_first_error: false,
                        price_type3_second_error: true,
                        price_error_msg: '请输入折扣价',
                        spinning: false,
                    });
                    return;
                } else if (Number(price_type3_first) < Number(price_type3_second)) {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: false,
                        price_type2_second_error: false,
                        price_type3_first_error: true,
                        price_type3_second_error: true,
                        price_error_msg: '市场价不能低于折扣价',
                        spinning: false,
                    });
                    return;
                } else {
                    this.setState({
                        price_type1_first_error: false,
                        price_type2_first_error: false,
                        price_type2_second_error: false,
                        price_type3_first_error: false,
                        price_type3_second_error: false,
                        price_error_msg: '',
                    });
                    price_first = price_type3_first;
                    price_second = price_type3_second;
                }
            }

            if (!sku_code) {
                this.setState({ 
                    spinning: false,
                });
                return;
            }

            if (!name) {
                this.setState({ 
                    spinning: false,
                });
                return;
            }

            const params = {
                name,
                price_first,
                price_second,
                price_type,
                sku_code,
                sku_id
            };

            api.post(
                params,
                { apiPath: `/live/products` }
            )
                .then(() => {
                    this.goBack();
                })
                .catch(errorHandle)
                .finally(() => {
                    this.setState({ 
                        spinning: false
                     });
                });
            
        });
    };

    // 查询商品
    getProduct = (e: any) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err: any, values: any) => {
            if (!err) {
                this.setState({ spinning: true });
                const { sku_code } = values;

                api.get(
                    {},
                    { apiPath: `/products/${trim(sku_code)}/simple_info` }
                )
                    .then((data: any) => {
                        const { name, price, skuCode, skuId } = data;
                        this.setState({
                            sku_id: skuId,
                            get_product_success: true,
                            price_error_msg: '',
                            price_type1_first_error: false,
                            price_type2_first_error: false,
                            price_type2_second_error: false,
                            price_type3_first_error: false,
                            price_type3_second_error: false
                        });

                        this.props.form.setFieldsValue({
                            name,
                            price_type1_first: price,
                            price_type2_first: price,
                            price_type3_first: price,
                            sku_code: skuCode,
                            price_type2_second: '',
                            price_type3_second: '',
                            price_type: 0,
                        });
                    }, (error) => {
                        errorHandle(error);

                        this.setState({
                            get_product_success: false
                        });
                    })
                    .finally(() => {
                        this.setState({ 
                            spinning: false,
                        });
                    });
            }
        });
    }

    goBack = () => {
        services.navigation.goto('/live-product');
    };

    render() {
        const {
            form: { getFieldDecorator },
        } = this.props;
        const { spinning, get_product_success, price_error_msg, price_type1_first_error, price_type2_first_error, price_type2_second_error, price_type3_first_error, price_type3_second_error } = this.state;
        return (
            <Fragment>
                <AntSpin spinning={spinning}>
                    <AntForm>
                        <AntForm.Item label="SKU">
                            {getFieldDecorator('sku_code', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入需要查询的商品SKU',
                                    }
                                ],
                            })(
                                <div style={{ display: 'flex' }}>
                                    <AntInput style={{ width: 400, marginRight: 16 }} />
                                    <AntButton type="primary" onClick={this.getProduct}>
                                        查询商品
                                    </AntButton>
                                </div>
                            )}
                        </AntForm.Item>
                    </AntForm>
                    <AntForm className='live-product-add-form'>
                        {get_product_success && (
                            <Fragment>
                                <AntForm.Item label="商品名称" className='live-product-add-name'>
                                    {getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入商品名称',
                                            }
                                        ],
                                    })(<AntInput style={{ width: 400, marginRight: 16 }} />)}
                                </AntForm.Item>
                                <AntForm.Item label="价格类型" className='live-product-add-price'>
                                    {getFieldDecorator('price_type', {})(
                                        <AntRadio.Group>
                                            <AntRadio className='radio-content' value={1}>
                                                <div className='radio-row'>
                                                    <div className='radio-row-title'>一口价</div>
                                                    {getFieldDecorator('price_type1_first', {})(
                                                        <AntInputNumber className={classnames('price-type1-first-input', { 'has-error': price_type1_first_error })} />
                                                    )}
                                                </div>
                                            </AntRadio>
                                            <AntRadio className='radio-content' value={2}>
                                                <div className='radio-row'>
                                                    <div className='radio-row-title'>价格区间</div>
                                                    {getFieldDecorator('price_type2_first', {})(
                                                        <AntInputNumber className={classnames('price-type2-first-input', { 'has-error': price_type2_first_error })} />
                                                    )}
                                                    至
                                                    {getFieldDecorator('price_type2_second', {})(
                                                        <AntInputNumber className={classnames('price-type2-second-input', { 'has-error': price_type2_second_error })} />
                                                    )}
                                                </div>
                                            </AntRadio>
                                            <AntRadio className='radio-content' value={3}>
                                                <div className='radio-row'>
                                                    <div className='radio-row-title'>折扣价</div>
                                                    市场价 {getFieldDecorator('price_type3_first', {})(
                                                        <AntInputNumber className={classnames('price-type3-first-input', { 'has-error': price_type3_first_error })} />
                                                    )}
                                                    折扣价 {getFieldDecorator('price_type3_second', {})(
                                                        <AntInputNumber className={classnames('price-type3-second-input', { 'has-error': price_type3_second_error })} />
                                                    )}
                                                </div>
                                            </AntRadio>
                                        </AntRadio.Group>
                                    )}
                                </AntForm.Item>
                                <div className='price_error_msg'>{price_error_msg}</div>
                                <AntForm.Item>
                                    <AntButton type="primary" onClick={this.handleSubmit}>
                                        保存并提审
                                    </AntButton>
                                    <AntButton style={{ marginLeft: 10 }} onClick={this.goBack}>
                                        取消
                                    </AntButton>
                                </AntForm.Item>
                            </Fragment>
                        )}
                    </AntForm>
                </AntSpin>
            </Fragment>
        )
    }
}

export const LiveProductAdd =  AntForm.create<ILiveProductAddProps>()(liveProductAdd);
